import React from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

function fmtMonth(m) {
  if (!m) return "";
  const [y, mo] = m.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(mo, 10) - 1]} ${y.slice(2)}`;
}

export default function MonthOnMonthChart({ series }) {
  const data = (series || []).map((s) => ({
    ...s,
    monthLabel: fmtMonth(s.month),
  }));

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="month-on-month-chart">
      <div className="rounded-md border border-slate-200 bg-white p-4">
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-sm font-semibold text-slate-800">Observations: Opened vs Resolved</h4>
          <span className="text-[10px] text-slate-500 uppercase tracking-wider">Last 12 mo.</span>
        </div>
        <div style={{ width: "100%", height: 220 }}>
          <ResponsiveContainer>
            <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
              <XAxis dataKey="monthLabel" tick={{ fontSize: 11, fill: "#64748b" }} stroke="#cbd5e1" />
              <YAxis tick={{ fontSize: 11, fill: "#64748b" }} stroke="#cbd5e1" allowDecimals={false} />
              <Tooltip contentStyle={{ fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} iconSize={8} />
              <Bar dataKey="opened" name="Opened" fill="#0B2A5B" radius={[3, 3, 0, 0]} />
              <Bar dataKey="resolved" name="Resolved" fill="#A8B86C" radius={[3, 3, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="rounded-md border border-slate-200 bg-white p-4">
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-sm font-semibold text-slate-800">Average Resolution Days (per month)</h4>
          <span className="text-[10px] text-slate-500 uppercase tracking-wider">Lower = faster</span>
        </div>
        <div style={{ width: "100%", height: 220 }}>
          <ResponsiveContainer>
            <LineChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
              <XAxis dataKey="monthLabel" tick={{ fontSize: 11, fill: "#64748b" }} stroke="#cbd5e1" />
              <YAxis tick={{ fontSize: 11, fill: "#64748b" }} stroke="#cbd5e1" />
              <Tooltip contentStyle={{ fontSize: 12 }} />
              <Line type="monotone" dataKey="avg_resolution_days" name="Avg days" stroke="#0B2A5B" strokeWidth={2} dot={{ r: 3, fill: "#0B2A5B" }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
